<script>

</script>

<style>
    h3 {
        background-color: #ccc;
        padding: 0.1em;
        border: 1px #aaa solid;
    }
</style>

<h3><slot></slot></h3>